import type { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  readonly label: string;
  readonly error?: string;
}

export const Input = ({ label, error, id, className = '', style, ...props }: InputProps) => {
  return (
    <div>
      <label
        htmlFor={id}
        style={{
          display: 'block',
          fontSize: 'var(--text-sm)',
          fontWeight: 'var(--font-weight-medium)',
          color: 'var(--text-secondary)',
        }}
      >
        {label}
      </label>
      <input
        id={id}
        className={`focus-ring ${className}`}
        style={{
          marginTop: 'var(--space-1)',
          display: 'block',
          width: '100%',
          borderRadius: 'var(--radius-md)',
          border: `1px solid ${error ? 'var(--color-error-500)' : 'var(--border-default)'}`,
          padding: 'var(--space-2) var(--space-3)',
          fontSize: 'var(--text-base)',
          backgroundColor: 'var(--bg-surface)',
          color: 'var(--text-primary)',
          outline: 'none',
          transition: `border-color var(--duration-fast) var(--ease-out)`,
          ...style,
        }}
        onFocus={(e) => {
          e.currentTarget.style.borderColor = error ? 'var(--color-error-500)' : 'var(--border-focus)';
        }}
        onBlur={(e) => {
          e.currentTarget.style.borderColor = error ? 'var(--color-error-500)' : 'var(--border-default)';
        }}
        {...props}
      />
      {error && (
        <p
          style={{
            marginTop: 'var(--space-1)',
            fontSize: 'var(--text-sm)',
            color: 'var(--color-error-600)',
          }}
        >
          {error}
        </p>
      )}
    </div>
  );
};
